<template>
  <BaseEditModal
    style="width: 90vw; height: 90vh"
    displayName="Conflicts Detected"
    helpFileName="ChannelConflictResolver"
    icon="mdi-play-speed"
    :masterObj="{}"
    :tabs="tabs"
    @close="emit('close')"
    :hideTabs="true"
    hideBottomButtons
    :customState="conflictResults">
    <template v-slot:prepend-buttons>
      <v-btn
        style="background-color: var(--inner-background)"
        @click="emit('close')"
        variant="flat">
        Close
      </v-btn>
    </template>
    <template v-slot:append-buttons>
      <v-btn
        @click="runImport()"
        :disabled="getResolvedConflictsCount(props.conflictResults) === 0"
        color="primary"
        variant="flat">
        Import
      </v-btn>
    </template>
  </BaseEditModal>
</template>
<script setup>
import BaseEditModal from '@/components/Shared/Modals/BaseEditModal.vue';
import ChannelConflictResolverTab from './ChannelConflictResolverTab.vue';
import { $http } from '../../../stores/http';
const props = defineProps([
  'conflictResults',
  'importFile',
  'queueOnly',
  'ch_uid',
]);

const emit = defineEmits(['close', 'locked']);

const tabs = [
  {
    id: 0,
    title: 'Please resolve the following conflicts',
    icon: 'mdi-rename-box',
    display: true,
    component: ChannelConflictResolverTab,
  },
];

function getResolvedConflictsCount(conflictResults) {
  if (!conflictResults) return 0;

  if (conflictResults.templates) {
    return Object.values(conflictResults.templates).reduce((acc, item) => {
      return (
        acc +
        Object.values(item.conflicts).filter((resolution) => !!resolution)
          .length
      );
    }, 0);
  }
  return 0;
}

async function runImport() {
  props.importFile.conflict = props.conflictResults;
  if (props.queueOnly) {
    await $http(
      'POST',
      `/dynamic_engine/import_queue?ch_uid=${props.ch_uid}`,
      JSON.stringify(props.importFile)
    );
  } else {
    await $http(
      'POST',
      '/dynamic_engine/import_channel',
      JSON.stringify(props.importFile)
    );
  }

  emit('close');
}
</script>
<style scoped></style>
